import {
  UserProfileDeletePudCcDocument,
  UserProfileDeletePudCcMutationVariables,
} from "@graphql/api";

export default async function userProfileDeletePudCc(
  pudId: number,
  ccId: number,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileDeletePudCcMutationVariables = {
    pudId,
    ccId,
  };

  const result = await client.mutate({
    mutation: UserProfileDeletePudCcDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileDeletePudCc.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileDeletePudCc.success ?? false;
}
